import React, { useState } from "react";

// Flagging a bad sentence. Categories come from the server so they stay in step with
// GrammarReviewCsv::VERDICTS — learner reports and proofreader verdicts should say the
// same thing.
export default function ReportSentence({ categories, reportUrl, sentenceId }) {
  const [open, setOpen] = useState(false);
  const [category, setCategory] = useState("");
  const [comment, setComment] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  const submit = (e) => {
    e.preventDefault();
    if (!category || sending) return;

    setSending(true);
    setError(null);
    $.ajax({
      method: "post",
      url: reportUrl,
      data: {
        grammar_exercise_cloze_sentence_id: sentenceId,
        category: category,
        comment: comment
      }
    })
      .done(() => {
        setSent(true);
        setOpen(false);
      })
      .fail((xhr) => {
        const errors = (xhr.responseJSON || {}).errors;
        setError(errors ? errors[0] : "Couldn't send that. Please try again.");
      })
      .always(() => setSending(false));
  };

  if (sent) {
    return (
      <span className="text-muted report-sent">
        <span className="glyphicon glyphicon-ok" /> Thanks — we'll take a look.
      </span>
    );
  }

  if (!open) {
    return (
      <button type="button" className="btn btn-link btn-xs report-btn" onClick={() => setOpen(true)}>
        Report a problem
      </button>
    );
  }

  return (
    <form className="report-form" onSubmit={submit}>
      <div className="form-group">
        <select
          className="form-control input-sm"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        >
          <option value="">What's wrong with it?</option>
          {Object.keys(categories).map((key) => (
            <option key={key} value={key}>{categories[key]}</option>
          ))}
        </select>
      </div>
      <div className="form-group">
        <input
          type="text"
          className="form-control input-sm"
          value={comment}
          maxLength={1000}
          placeholder="Anything to add? (optional)"
          onChange={(e) => setComment(e.target.value)}
        />
      </div>
      <button type="submit" className="btn btn-default btn-xs" disabled={sending || !category}>
        {sending ? "Sending..." : "Send report"}
      </button>
      {" "}
      <button type="button" className="btn btn-link btn-xs" onClick={() => setOpen(false)}>
        Cancel
      </button>
      {error && <p className="text-danger">{error}</p>}
    </form>
  );
}
